/**
 * Endpoints du reporting fédéré — guide v1.2 §7 / §6.x Reporting.
 *
 * 27 routes : 5 services × (series, summary, gauges, export.csv, metrics)
 * + gateway overview / metrics. `metrics` (Prometheus) est déclaré pour
 * parité, hors UI. Ne jamais inventer un chemin.
 */

const serviceReporting = (gatewayPrefix: string) =>
  ({
    /** GET — série journalière. Query : from, to, metricKey, currency. */
    series: `${gatewayPrefix}/Reporting/series`,
    /** GET — totaux de période + jauges. Query : from, to. */
    summary: `${gatewayPrefix}/Reporting/summary`,
    /** GET — jauges d'état instantané (supervision légère). */
    gauges: `${gatewayPrefix}/Reporting/gauges`,
    /** GET — même série en CSV (`;` + BOM UTF-8). */
    exportCsv: `${gatewayPrefix}/Reporting/export.csv`,
    /** GET — texte Prometheus (hors UI). */
    metrics: `${gatewayPrefix}/Reporting/metrics`,
  }) as const;

export const reportingEndpoints = {
  gateway: {
    /** GET — vue consolidée des 5 services. Query : from, to. */
    overview: "/api/v1/Reporting/overview",
    /** GET — Prometheus consolidé (hors UI). */
    metrics: "/api/v1/Reporting/metrics",
  },
  kyc: serviceReporting("/gw/kyc/api/v1"),
  wallet: serviceReporting("/gw/wallet/api/v1"),
  ledger: serviceReporting("/gw/ledger/api/v1"),
  "fee-engine": serviceReporting("/gw/fee-engine/api/v1"),
  merchant: serviceReporting("/gw/merchant/api/v1"),
  /**
   * Admin — guide v2.5 §6.8 : seul `metrics` est exposé (pas de series /
   * summary / gauges / exportCsv). Hors UI, pour parité supervision.
   */
  admin: {
    metrics: "/gw/admin/api/v1/Reporting/metrics",
  },
} as const;

/**
 * Services qui exposent le contrat de reporting complet
 * (series / summary / gauges / exportCsv / metrics). `admin` n'exporte que
 * `metrics` (v2.5) et reste exclu ; `gateway` compose la vue consolidée.
 */
export type ReportingService = Exclude<
  keyof typeof reportingEndpoints,
  "gateway" | "admin"
>;
